// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { type Tag } from '../../brokers/types'
import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

type ModifyTagArchivedStatusParams = {
  archived: boolean
}

export function useModifyTagArchivedStatus ({ id } : { id: string }) {
  return useMutation<Tag, GrapeAPIErrorType, ModifyTagArchivedStatusParams>({
    mutationFn: async (params) => {
      const request = new FetchRequest(
        'patch',
        `/api/web/brokers/tags/${id}/archived`,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: {
            ...params,
          },
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
